import type { JSX } from 'react';
import { styled } from '@mui/material';
import { corePalette } from '@/themes/colours';

const Badge = styled('span')({
  flexShrink: 0,
  maxWidth: '112px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  borderRadius: '4px',
  padding: '2px 4px',
  background: corePalette.grey100,
  color: corePalette.white,
  fontSize: '11px',
  fontWeight: 500,
  lineHeight: '14px',
  textTransform: 'uppercase',
});

interface IProps {
  label: string;
  backgroundColor?: string;
  color?: string;
}

export default function TimelinePopupBadge({
  label,
  backgroundColor,
  color,
}: IProps): JSX.Element {
  return <Badge style={{ background: backgroundColor, color }}>{label}</Badge>;
}
